import { render, staticRenderFns } from "./UpdateOrderPrice.vue?vue&type=template&id=680e0c08"
import script from "./UpdateOrderPrice.vue?vue&type=script&lang=js"
export * from "./UpdateOrderPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports